import { useState } from 'react'

import { Button } from '@ui/components/core'
import { CreateOrganizationModal } from '@ui/pages/manage/components/CreateOrganizationModal'

import { CreateInstanceModal } from './AdminPanel/CreateInstanceModal'
import { InstanceComponent } from './AdminPanel/Instance'
import { OrganizationComponent } from './AdminPanel/Organization'

enum AdminPanelTab {
  ORGANIZATION,
  INSTANCE,
}

export const AdminPanel = () => {
  const [currentTab, setCurrentTab] = useState(AdminPanelTab.ORGANIZATION)
  const [modalState, setModalState] = useState(false)

  const setModalOpen = () => {
    setModalState(true)
  }

  const setModalClosed = () => {
    setModalState(false)
  }

  const selectedTabCss =
    'whitespace-nowrap border-b-2 border-primary-500 px-1 py-3 text-sm font-medium text-primary-600 cursor-pointer'
  const unselectedTabCss =
    'whitespace-nowrap border-b-2 border-transparent px-1 py-3 text-sm font-medium text-gray-500 border-gray-400 hover:text-gray-700 cursor-pointer'

  const changeTabToOrganization = () => setCurrentTab(AdminPanelTab.ORGANIZATION)
  const changeTabToInstance = () => setCurrentTab(AdminPanelTab.INSTANCE)

  return (
    <div className="w-full max-w-[calc(100vw-5rem)]">
      {currentTab === AdminPanelTab.ORGANIZATION && (
        <CreateOrganizationModal
          fetchOrganizations={() => {}} // This will be handled in the OrganizationComponent
          modalState={modalState}
          setModalClosed={setModalClosed}
        />
      )}
      {currentTab === AdminPanelTab.INSTANCE && (
        <CreateInstanceModal
          fetchInstances={() => {}} // This will be handled in the InstanceComponent
          modalState={modalState}
          setModalClosed={setModalClosed}
          orgId={0} // You might need to pass the correct orgId here
        />
      )}
      <div className="h-full">
        <div className="flex w-full">
          <div className="flex-auto">
            <div className="-mb-px flex space-x-8" aria-label="Tabs">
              <a
                onClick={changeTabToOrganization}
                className={currentTab === AdminPanelTab.ORGANIZATION ? selectedTabCss : unselectedTabCss}>
                Organization
              </a>
              <a
                onClick={changeTabToInstance}
                className={currentTab === AdminPanelTab.INSTANCE ? selectedTabCss : unselectedTabCss}>
                Instance
              </a>
            </div>
          </div>
          <div className="">
            <Button size="large" onClick={() => setModalOpen()}>
              Add {currentTab === AdminPanelTab.ORGANIZATION ? 'organization' : 'instance'}
            </Button>
          </div>
        </div>

        {currentTab === AdminPanelTab.ORGANIZATION && <OrganizationComponent />}
        {currentTab === AdminPanelTab.INSTANCE && <InstanceComponent />}
      </div>
    </div>
  )
}
